import styled from '@emotion/styled';

export default styled.div<{ gap?: number; flexDirection?: string; height?: number }>`
  height: ${({ height }) => (height ? `${height}px` : '100%')};
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection ?? 'column'};
  gap: ${({ gap }) => gap ?? 0}px;
`;
